import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { searchResultsExecutionStatus, } from '@as-react/common-types';
import { capitalize } from '@as-react/common-utils';
import { Banner, TextAlpha } from '@yonderland/andes-react';
import { useMemo } from 'react';
import { useProductListerContext } from '../context/ProductListerContext';
const INITIAL_QUERY_PLACEHOLDER = '{{{INITIAL QUERY}}}';
const ALTERNATIVE_BRAND_PLACEHOLDER = '{{{ALTERNATIVE BRAND}}}';
const splitByPlaceholder = (text, placeholder) => {
    const [before = '', after = ''] = text.split(placeholder);
    return [before, after];
};
const hasValidTitleAndDescription = (executionStatus, partialSearchResults) => {
    const { alternativeBrand, maybeMeant, maybeLike, changedMisspelling } = partialSearchResults;
    const statusToResult = {
        [searchResultsExecutionStatus.ALT_BRAND]: alternativeBrand,
        [searchResultsExecutionStatus.ALT_QUERIES]: maybeMeant,
        [searchResultsExecutionStatus.ALT_SPELL_UNCHANGED]: maybeLike,
        [searchResultsExecutionStatus.ALT_SPELL_CHANGED]: changedMisspelling,
    };
    const result = statusToResult[executionStatus];
    return !!((result === null || result === void 0 ? void 0 : result.title) && (result === null || result === void 0 ? void 0 : result.description));
};
export const PartialSearchResultsBanner = () => {
    var _a;
    const { urlState: { q: query }, partialSearchResults, query: { data: { executionStatus, alternativeQueryResults } = {} }, } = useProductListerContext();
    const suggestedSearchTerm = capitalize(((_a = alternativeQueryResults === null || alternativeQueryResults === void 0 ? void 0 : alternativeQueryResults[0]) === null || _a === void 0 ? void 0 : _a.alternativeQuery) || '');
    const bannerContent = useMemo(() => {
        if (!partialSearchResults ||
            !executionStatus ||
            !query ||
            !hasValidTitleAndDescription(executionStatus, partialSearchResults)) {
            return null;
        }
        const { alternativeBrand, maybeMeant, maybeLike, changedMisspelling } = partialSearchResults;
        switch (executionStatus) {
            case searchResultsExecutionStatus.ALT_BRAND: {
                const [before, after] = splitByPlaceholder(alternativeBrand.title, ALTERNATIVE_BRAND_PLACEHOLDER);
                return {
                    titles: [before.replace(INITIAL_QUERY_PLACEHOLDER, query), suggestedSearchTerm, after],
                    description: alternativeBrand.description.replace(ALTERNATIVE_BRAND_PLACEHOLDER, suggestedSearchTerm),
                };
            }
            case searchResultsExecutionStatus.ALT_QUERIES: {
                const [before, after] = splitByPlaceholder(maybeMeant.title, INITIAL_QUERY_PLACEHOLDER);
                return { titles: [before, query, after], description: maybeMeant.description };
            }
            case searchResultsExecutionStatus.ALT_SPELL_UNCHANGED: {
                const [before, after] = splitByPlaceholder(maybeLike.title, INITIAL_QUERY_PLACEHOLDER);
                return { titles: [before, query, after], description: maybeLike.description };
            }
            case searchResultsExecutionStatus.ALT_SPELL_CHANGED: {
                const [before, after] = splitByPlaceholder(changedMisspelling.title, INITIAL_QUERY_PLACEHOLDER);
                return { titles: [before, query, after], description: changedMisspelling.description };
            }
            default:
                return null;
        }
    }, [partialSearchResults, executionStatus, query, suggestedSearchTerm]);
    if (!bannerContent || !(alternativeQueryResults === null || alternativeQueryResults === void 0 ? void 0 : alternativeQueryResults.length)) {
        return null;
    }
    const { titles, description } = bannerContent;
    const [titlePrefix, titleSearch, titleSuffix] = titles;
    const showSuggestedTerm = alternativeQueryResults.length === 1 && suggestedSearchTerm;
    return (_jsx(Banner, { status: "neutral", text: _jsxs(_Fragment, { children: [_jsxs(TextAlpha, { testId: `lister-heading-title${executionStatus}`, children: [titlePrefix, _jsx(TextAlpha, { as: "span", variant: "inherit", strong: true, children: titleSearch }), titleSuffix] }), _jsx(TextAlpha, { as: "span", children: description }), showSuggestedTerm && (_jsxs(TextAlpha, { as: "span", variant: "inherit", strong: true, testId: "lister-heading-alternative-title", children: [' ', suggestedSearchTerm] }))] }) }));
};
